import { TouchpointVersionFeedbackRequestType } from "generated/schemas";

import { AI_CONTENT_PREVIEW_AREA_OPTIONS } from "./ai-content-feedback.constants";
import type { AiContentPreviewArea, AiContentVote } from "./ai-content-feedback.types";

export function mapVoteToFeedbackType(vote: AiContentVote): TouchpointVersionFeedbackRequestType {
  return vote === "looks_good"
    ? TouchpointVersionFeedbackRequestType.POSITIVE
    : TouchpointVersionFeedbackRequestType.NEGATIVE;
}

export function buildFeedbackComment(
  feedback: string,
  previewAreas: AiContentPreviewArea[],
): string {
  const trimmedFeedback = feedback.trim();

  if (previewAreas.length === 0) {
    return trimmedFeedback;
  }

  const areaLabels = previewAreas
    .map(
      (areaId) =>
        AI_CONTENT_PREVIEW_AREA_OPTIONS.find((option) => option.id === areaId)?.label,
    )
    .filter((label): label is string => Boolean(label))
    .join(", ");

  if (!areaLabels) {
    return trimmedFeedback;
  }

  return `Preview areas: ${areaLabels}\n\n${trimmedFeedback}`;
}
